import { render, staticRenderFns } from "./FordaysBannerLogo.vue?vue&type=template&id=68c874bf&scoped=true&"
import script from "./FordaysBannerLogo.vue?vue&type=script&lang=js&"
export * from "./FordaysBannerLogo.vue?vue&type=script&lang=js&"
import style0 from "./FordaysBannerLogo.vue?vue&type=style&index=0&id=68c874bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c874bf",
  null
  
)

export default component.exports